import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/_services/api.service';
import { first } from 'rxjs/operators';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Location } from '@angular/common';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-family-allowance-view',
  templateUrl: './family-allowance-view.component.html',
  styleUrls: ['./family-allowance-view.component.scss']
})
export class FamilyAllowanceViewComponent implements OnInit {

  family_allowance_id: any;
  response: any;
  employees: any;
  child: any;
  spouse: any;
  employer: any;
  userDetails: any;
  currentUser: any;
  accountDetails: any;
  employerFamilyAllowance: any;
  id: any;
  value: any;
  rejectReason: any;
  currentLang: any;
  signature: any;
  showAll: boolean = false;

  constructor(private api: ApiService,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private router: Router,
    private ngxUiLoaderService: NgxUiLoaderService,
    private location: Location) {
    const data = localStorage.getItem('currentUserDetails');
    if (data) {
      this.accountDetails = JSON.parse(data);
      this.currentUser = this.accountDetails.current_user;
      console.log("current-user :", this.currentUser)
    }
    if (this.router.getCurrentNavigation().extras.state) {
      console.log(this.router.getCurrentNavigation().extras)
      this.value = this.router.getCurrentNavigation().extras.state.data;
      console.log("47", this.value)
      if (this.value == '1') {
        this.getViewAllowanceReports()
      }

    } else {
      // this.router.navigate(['/cnss-reportList']
    }
  }

  ngOnInit() {
    this.route.params.subscribe(data => {
      console.log("params", data);
      this.family_allowance_id = data['id'];
      console.log("idddddddd", this.family_allowance_id);
      if (this.family_allowance_id) {
        this.getViewAllowanceReports()
      }

    })
  }

  goBack() {
    this.location.back();
  }


  getViewAllowanceReports() {
    this.ngxUiLoaderService.start();
    if (this.family_allowance_id) {
      var data = this.family_allowance_id;
    }
    this.api.getViewAllowanceReports(data).pipe(first())
      .subscribe(data => {
        this.ngxUiLoaderService.stop();
        this.response = data
        console.log(this.response);
        if (this.response.status == 200) {
          this.employees = this.response.results.employee;
          this.employer = this.response.results.employer;
          this.spouse = this.response.results.spouse;
          this.child = this.response.results.child;
          this.rejectReason = this.response.verification;
          this.signature = this.employees.signature;
        }
      })
  }

  employerAllowanceSubmit() {
    let data = {
      allowance_id: this.employees.allowance_id
    };
    this.ngxUiLoaderService.start();
    this.api.submitEmployerAllowance(data).pipe(first()).subscribe(result => {
      this.ngxUiLoaderService.stop();
      console.log("Response", result);
      this.employerFamilyAllowance = result;
      this.id = result.uuid;

      if (this.employerFamilyAllowance.status == 200) {
        this.snackBar.open(this.employerFamilyAllowance.message, "OK", {
          duration: 5000,
        });
        console.log("2222222222222222222222", this.id)
        this.router.navigate(["/family-allowance-list", this.id]);
      } else {
        this.snackBar.open(this.employerFamilyAllowance.message, "OK", {
          duration: 5000,
        });
      }
    }, error => {
      this.ngxUiLoaderService.stop();
    });
  }

  view() {
    this.showAll = !this.showAll;
    if (this.showAll) {
      console.log("244", this.currentLang)
      if (this.currentLang == 'fr') {
        $("#view").text('Voir plus')
      } else {
        $("#view").text('View more')
      }
    } else {
      console.log("252", this.currentLang)
      if (this.currentLang == 'fr') {
        $("#view").text('Voir moins')
      } else {
        $("#view").text('View less')
      }

    }
  }
}
